import { theme } from '@frontend/theme';

export const HEADER_SHADOW = `0 4px 6px -2px ${theme.colors.primary90}4C`;
